<template>
  <div class="sharedata-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            数据分享
            <el-button size="small" icon="el-icon-circle-plus-outline" @click="editRow(null)" style="margin-left: 70px" type="text">我来分享</el-button>
            <div class="search-mode">
              <input type="text" class="search-input" placeholder="关键字搜索" v-model="search" />
              <el-button class="search-btn" icon="el-icon-search" @click="searchShare"/>
            </div>
          </div>
          <div class="card-content">
            <el-row>
              <el-col :span="5">
                <ul class="group-filter">
                  <li :class="sort===0?'active':''" @click="getSortData(0)">最新添加</li>
                  <li :class="sort===1?'active':''" @click="getSortData(1)">收藏最多</li>
                  <li :class="sort===2?'active':''" @click="getSortData(2)">浏览最多</li>
                </ul>
              </el-col>
              <el-col :span="19" v-loading="tableLoading">
                <el-table
                  :data="data"
                  style="width: 100%">
                  <el-table-column
                    prop="name"
                    label="#"
                    align="center"
                    width="150">
                    <template slot-scope="scope">
                      <el-image :src="scope.row.img_url" fit="contain" style="width: 100%;height: 40px;"
                                :preview-src-list="[scope.row.img_url]">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="share_name"
                    label="分享标题"
                    :show-overflow-tooltip="true"
                    align="center">
                    <template slot-scope="scope">
                      <div style="cursor: pointer;" @click="goDetail(scope.row)">{{scope.row.share_name}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="user_name"
                    label="分享人"
                    align="center"
                    width="90">
                  </el-table-column>
                  <el-table-column
                    prop="share_time"
                    align="center"
                    label="分享时间"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="total_views"
                    label="浏览量"
                    align="center"
                    width="90">
                  </el-table-column>
                  <el-table-column
                    prop="views"
                    label="浏览人数"
                    align="center"
                    width="90">
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    align="center"
                    width="185"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button @click.stop="editRow(scope.row)"  type="primary" size="mini" icon="el-icon-edit-outline" >编辑</el-button>
                      <el-button @click.stop="deleteRow(scope.row)" type="danger" size="mini" icon="el-icon-delete">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="addShareData.shareId===0?'添加分享':'修改分享'"
      :visible.sync="dialogVisible"
      width="60%"
      top="8vh"
      :destroy-on-close="true"
      :append-to-body="true"
      :lock-scroll="true"
      :before-close="handleClose">
      <el-form v-loading="addShareData.loading" :key="addShareData.shareId" ref="form" :model="addShareData" :rules="rules" label-width="80px" size="small" style="padding:15px 25px 15px 15px;">
        <el-form-item label="标题" prop="title">
          <el-input v-model="addShareData.title" maxlength="100"/>
        </el-form-item>
        <el-form-item label="封面图片" prop="img">
          <SingleImg :key="addShareData.key" v-model="addShareData.singleImg" :oldurl="addShareData.oldImageUrl"/>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <tinymce :key="addShareData.key" v-model="addShareData.content" :height="200"/>
        </el-form-item>
        <el-form-item label="上传图片">
          <MultiImg :key="addShareData.key" v-model="addShareData.multiImg" :limit="9" :size="'sm'" :old="addShareData.oldImages"/>
        </el-form-item>
        <el-form-item label="上传文件">
          <MultiFile :key="addShareData.key" v-model="addShareData.multiFiles" :limit="9" :size="'sm'" :old="addShareData.oldFiles"/>
        </el-form-item>
        <el-form-item>
          <el-button :loading="btnLoading" type="primary" @click="addShare('form')">立即提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getUserShareData} from '@/api/work'
import { addShare } from '@/api/study/sharedata'
import { deleteShare} from '@/api/work'
import { editShareData} from '@/api/work'
import { getShareDataDetail} from '@/api/study/sharedata'
import SingleImg from '@/components/upload/SingleImg'
import Tinymce from '@/components/Tinymce'
import MultiImg from '@/components/upload/MultiImg'
import MultiFile from '@/components/upload/MultiFile'

export default {
  name: 'Sharedata',
  components:{
    MultiFile,
    MultiImg,
    SingleImg,Tinymce
  },
  computed: {
    user: getUser
  },
  data() {
    return {
      btnLoading: false,
      tableLoading: false,
      sort: 0,
      search: '',
      loading: false,
      data: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      rules: {
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        img: [
          { required: true, message: '请上传封面图片', trigger: 'blur' }
        ]
      },
      addShareData:{
        singleImg: {
          imgid: '',
          imgurl: ''
        },
        multiImg: [],
        multiFiles: [],
        title: '',
        content: '',
        shareId: 0,
        oldImages: [],
        oldFiles: [],
        oldImageId: '',
        oldImageUrl: '',
        key: '',
        loading: false
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    goDetail(row){
      this.$router.push({path:'/study/sharedata_detail/' + row.shareId})
    },
    getData() {
      this.tableLoading = true
      let _this = this
      const data = {
        page: _this.currentPage,
        limit: _this.pageSize,
        type: _this.sort,
        userid: _this.user.dUserid,
        mark: 1,
        content: _this.search
      }

      getUserShareData(data).then(response=>{
        _this.data = response.data
        _this.total = response.total
        _this.tableLoading = false
        _this.tableLoading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    searchShare(){
      this.currentPage = 1
      this.getData()
    },
    getSortData(sort){
      this.sort = sort
      this.getData()
    },
    handleClose(done){
      this.addShareData.content = ''
      this.addShareData.multiFiles = []
      this.addShareData.multiImg = []
      this.addShareData.singleImg.imgurl = ''
      this.addShareData.singleImg.imgid = ''
      this.addShareData.title = ''
      done();
    },
    addShare(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.addShareData.oldImageId==='' && this.addShareData.singleImg.imgid===''){
            this.$message({
              type: 'waring',
              message: '请选择封面图片'
            });
            return false
          }
          this.btnLoading = true
          let id = this.addShareData.singleImg.imgid
          if(id===''){
            id = this.addShareData.oldImageId
          }
          let data = {
            imgid: id,
            title: this.addShareData.title,
            content: this.addShareData.content,
            userid: this.user.dUserid,
            imgids: this.addShareData.multiImg.toString(),
            fileids: this.addShareData.multiFiles.toString(),
            shareid: 0
          }
          if(this.addShareData.shareId===0){
            addShare(data).then(response=>{
              this.$message({
                type: 'success',
                message: '提交成功'
              });
              this.dialogVisible = false
              this.btnLoading = false
              this.getData()
            }).catch(() => {
              this.btnLoading = false
            });
          }else {
            data.shareid = this.addShareData.shareId
            editShareData(data).then(response=>{
              this.$message({
                type: 'success',
                message: '提交成功'
              });
              this.btnLoading = false
              this.dialogVisible = false
              this.getData()
            }).catch(() => {
              this.btnLoading = false
            });
          }
        } else {
          return false;
        }
      });
    },
    editRow(row){
      this.addShareData.loading = true
      this.dialogVisible = true
      this.addShareData.oldFiles = []
      this.addShareData.oldImages = []
      if(row!==null){
        getShareDataDetail({shareid: row.shareId,userid: this.user.dUserid,isEdit: 1}).then(response=>{
          const shareDetail = response.data.shareDetail
          this.addShareData.content = shareDetail.share_content
          this.addShareData.title = shareDetail.share_title
          this.addShareData.shareId = row.shareId
          this.addShareData.oldImageId = shareDetail.img_id
          this.addShareData.oldImageUrl = shareDetail.img_url
          if(shareDetail.fileList.length>0){
            for(let item of shareDetail.fileList){
              const file = {
                id: item.file_id,
                url: item.file_path,
                name:item.file_name+'.'+item.type
              }
              this.addShareData.oldFiles.push(file)
            }
          }
          if(shareDetail.imageList.length>0){
            for(let item of shareDetail.imageList){
              const file = {
                id: item.dImgid,
                url: item.img_url
              }
              this.addShareData.oldImages.push(file)
            }
          }
          this.addShareData.key = new Date().getTime().toString()
          this.addShareData.loading = false
        })
      }else {
        this.addShareData.shareId = 0
        this.addShareData.oldImageUrl = ''
        this.addShareData.oldImageId = ''
        this.addShareData.key = new Date().getTime().toString()
        this.addShareData.loading = false
      }
    },
    deleteRow(row){
      if(row!=null){
        this.$confirm('您确定要删除这条分享吗?', '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          const data = {
            shareid: row.shareId
          }
          deleteShare(data).then(response=>{
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getData()
          })
        }).catch(() => {
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          font-weight: 500;
          color: #404852;
          margin-bottom: 22px;
          font-size: 14px;
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
</style>
